// extracted by mini-css-extract-plugin
export var directionDescription = "direction-navigation-link-module--directionDescription--VpqXx";
export var iconForward = "direction-navigation-link-module--icon-forward--pDstf";
export var mainContainer = "direction-navigation-link-module--mainContainer--vKLO0";
export var nextLayout = "direction-navigation-link-module--nextLayout--kQbvC";
export var previousLayout = "direction-navigation-link-module--previousLayout--37ElW";
export var redirectLink = "direction-navigation-link-module--redirectLink--a3ksA";
export var textDescription = "direction-navigation-link-module--textDescription--0Xg7Z";
export var titleText = "direction-navigation-link-module--titleText--bWroS";